import React, { Component } from "react";
import { format } from "date-fns";
import svLocale from "date-fns/locale/sv";

import getImageObject from "src/helpers/getImageObject";
import SectionLight from "src/components/Modules/SectionLight";
import PageStyles from "src/components/styles/PageStyles";
import ContentWrapper from "src/components/UI/Structure/ContentWrapper";
import SEO from "src/components/Modules/SEO";
import Hero from "src/components/Modules/Hero";
import Container from "src/components/UI/Grid/Container";
import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Flex from "src/components/UI/Structure/Flex";
import Box from "src/components/UI/Structure/Box";
import Button from "src/components/UI/Button";
import Content from "src/components/Modules/Content";

import RelatedArtist from "./RelatedArtist/RelatedArtist";
import SocialShare from "./SocialShare/SocialShare";

class PostTemplate extends Component {
  render() {
    // Get page data
    const { previewData, gatsbyData, location } = this.props;

    // Choose data based on gatsby or preview mode
    const post = previewData ? previewData : gatsbyData;
    const relatedArtist = post.acfNewsPage.relatedArtist;

    // Set page data
    const { title, content, date, featuredImage } = post;

    const formattedDate = format(new Date(date), "dd MMM yyyy", {
      locale: svLocale,
    });
    const images = getImageObject(featuredImage);

    // SEO
    let seoDescription = "";
    if (content && content.preamble) {
      seoDescription = content.preamble.replace(/<\/?[^>]+(>|$)/g, "");

      if (seoDescription.length > 220) {
        seoDescription = seoDescription.slice(0, 220) + "...";
      }
    }
    // Social links
    const socials = {
      facebook: {
        url: location.href,
        label: "Dela på Facebook",
      },
      twitter: {
        url: location.href,
        label: "Dela på Twitter",
      },
    };
    return (
      <PageStyles>
        <SEO
          title={title}
          summary={seoDescription}
          description={seoDescription}
          ogImage={images}
        />
        <SectionLight>
          <Hero
            small
            size="small"
            headerColor="light"
            background={images ? true : false}
            images={images}
            title={title}
            label={"Test"}
            label={formattedDate ? formattedDate : ""}
          />
        </SectionLight>
        <ContentWrapper>
          <Container py={[5, null, null, null, 10]}>
            <Grid justifyContent="space-around">
              <Column width={[12 / 12, null, 10 / 12, null, 5 / 12]}>
                {/* Content */}
                {content && (
                  <Box mb={[8, null, null, 10]}>
                    <Content content={content} />
                  </Box>
                )}
                {/* Socials */}
                {socials && (
                  <Box mb={[8, null, null, 10]}>
                    <SocialShare socials={socials} />
                  </Box>
                )}
              </Column>

              {/* Related artist */}
              <Column
                width={[12 / 12, null, 10 / 12, null, 4 / 12]}
                mb={[8, null, null, null, 15]}
              >
                {relatedArtist && (
                  <RelatedArtist
                    relatedArtist={relatedArtist}
                    location={location}
                  />
                )}
              </Column>
            </Grid>

            <Flex justifyContent="center" alignItems="center">
              <Box>
                <Button label="Visa alla nyheter" link="/nyheter" size="large">
                  Visa alla nyheter
                </Button>
              </Box>
            </Flex>
          </Container>
        </ContentWrapper>
      </PageStyles>
    );
  }
}

export default PostTemplate;
